import { atom } from 'recoil';

export const askVennPanelOpenAtom = atom<boolean>({
  key: 'askVennPanelOpen',
  default: false,
});

export const askVennPendingMessageAtom = atom<string | undefined>({
  key: 'askVennPendingMessage',
  default: undefined,
});
